export async function checkPolicy(to, from, next) {
	if (to.params.policy && /^-?\d+$/.test((to.params.policy))) {
		next();
	} else {
		next({ name: "individual" })
	}
}

